import React from 'react';
import { useMutation } from 'react-fetching-library';
import { JsonForms } from '@jsonforms/react';
import {
  materialCells,
  materialRenderers
} from '@jsonforms/material-renderers';
import { Button, Modal, Portal, Card, CardContent, CardHeader, CardActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HorizontalResponsiveRenderer, { HorizontalResponsiveTester } from '../../../../../../components/json-forms/layouts/HorizontalResponsive';
import TextRenderer, { TextTester } from '../../../../../../components/json-forms/layouts/Text';
import { schema, uischema } from './schemas';
import { useApplication } from '../../../ApplicationsContext';
import { updateQuestionnaireAction } from '../../../../../../services/request';
import { formatDateTime } from '../../../../../../services/functions';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';

dayjs.locale('pl');


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function PreviewQuestionnaire({ handleClose }) {
  const { rowData, setRowData } = useApplication();
  const [data, setData] = React.useState(rowData.questionnaire_data.data);
  const [errors, setErrors] = React.useState([]);
  const [validationMode, setValidationMode] = React.useState('ValidateAndHide');
  const { mutate, loading } = useMutation(updateQuestionnaireAction);

  const translator = (key, defaultMessage) => {

    if (key.endsWith('.required')) {
      return 'To pole jest wymagane';
    }

    if (key.endsWith('.pattern') || key.endsWith('.format')) {
      return 'Niepoprawna wartość pola';
    }

    return defaultMessage;
  };

  const renderers = [
    ...materialRenderers,
    { tester: HorizontalResponsiveTester, renderer: HorizontalResponsiveRenderer },
    { tester: TextTester, renderer: TextRenderer }
  ];

  console.log(rowData);

  const handleSubmit = async () => {
    setValidationMode('ValidateAndShow');
    let visibleErrors = 0;
    errors.forEach(error => {
      if (document.querySelector(`[id^="#/properties/${error.params.missingProperty}2"]`) !== null) {
        visibleErrors++;
      }
    });

    if (visibleErrors === 0) {
      const { error, payload } = await mutate(rowData.questionnaire_data.id, { data });
      if (!error) {
        console.log(payload);
        setRowData(prev => ({ ...prev, questionnaire_data: { ...prev.questionnaire_data, data: payload.data } }));
        handleClose();
      }
    }
  };

  return (
    <Portal>
      <Modal open={true} onClose={handleClose}>
        <Card style={{ width: '60vw', maxHeight: '80vh', ...style, display: 'flex', flexDirection: 'column' }}>
          <CardHeader title={`Wypełniony kwestionariusz (${formatDateTime(rowData.questionnaire_data.createdAt)})`} action={<IconButton onClick={handleClose}><CloseIcon /></IconButton>}/>
          <CardContent style={{ overflow: 'auto', flex: 1 }}>
            <JsonForms
              i18n={{ locale: 'pl', translate: translator }}
              schema={schema}
              uischema={uischema}
              data={data}
              renderers={renderers}
              cells={materialCells}
              onChange={({ errors, data: newData }) => {
                setData(newData);
                setErrors(errors);
              }}
              validationMode={validationMode}
            />
          </CardContent>
          <CardActions>
            <Button variant="contained" fullWidth disabled={loading} onClick={handleSubmit}>
              edytuj
            </Button>
          </CardActions>
        </Card>
      </Modal>
    </Portal>
  );
};
